var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevrondownIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7511 8.99978C15.553 9.00446 15.3649 9.08731 15.2277 9.23025L11.7579 12.7L8.28822 9.23025C8.21831 9.15826 8.13467 9.10102 8.04224 9.06194C7.94982 9.02286 7.85049 9.00272 7.75014 9.00271C7.60088 9.00275 7.45502 9.04732 7.33123 9.13071C7.20744 9.21411 7.11135 9.33254 7.05524 9.47086C6.99914 9.60917 6.98558 9.76108 7.0163 9.90715C7.04702 10.0532 7.12061 10.1868 7.22768 10.2908L11.2277 14.2908C11.3683 14.4314 11.5591 14.5104 11.7579 14.5104C11.9568 14.5104 12.1476 14.4314 12.2882 14.2908L16.2882 10.2908C16.3973 10.1861 16.4722 10.0509 16.5031 9.90295C16.534 9.75497 16.5194 9.6011 16.4614 9.46153C16.4033 9.32196 16.3044 9.20318 16.1777 9.12079C16.0509 9.03839 15.9022 8.99621 15.7511 8.99978Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondownIco);
export default __webpack_public_path__ + "static/media/chevrondown-ico.c405696d.svg";
export { ForwardRef as ReactComponent };